import { Link } from 'react-router-dom';

export default function Footer() {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="text-2xl font-bold text-blue-400" style={{ fontFamily: 'Calibri, sans-serif' }} onClick={handleLinkClick}>
              QBOVerifier
            </Link>
            <p className="mt-4 text-gray-300 max-w-md">
              Protect your business reputation and prevent invoice fraud with our secure QuickBooks extension. 
              Ensure your clients trust every invoice you send.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="https://www.linkedin.com/in/Harry-Hollander-ArdeunBiometrics" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>

            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/how-it-works" className="text-gray-300 hover:text-white transition-colors" onClick={handleLinkClick}>How it Works</Link></li>
              <li><Link to="/pricing" className="text-gray-300 hover:text-white transition-colors" onClick={handleLinkClick}>Pricing</Link></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Chrome Extension</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">QuickBooks App</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors" onClick={handleLinkClick}>About</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors" onClick={handleLinkClick}>Contact</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors" onClick={handleLinkClick}>Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-300 hover:text-white transition-colors" onClick={handleLinkClick}>Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2026 QBOVerifier, bioMail, Ardeun Biometrics Corporation - All rights reserved.&nbsp; Patents and Patents Pending
          </p>
        </div>
      </div>
    </footer>
  );
}
